module.exports = __webpack_public_path__ + "img/Markets & festivals.07501356.png";